import axiosInstance from "../interceptor";
import { takeLatest, call, put } from "redux-saga/effects"; //takeEvery
import { actionTypes } from "../actionTypes/adminDashboard";
import { API_URL } from "../../config";
import { popUpAlert } from "../../utils/globalMethods";

function* getVendorStatsSaga(props) {
    let url =  `${API_URL}/vendor/stats`;
    try {
        const uri = url;
        const result = yield call(axiosInstance.post, uri, props.payload);  
            yield put({ type: actionTypes.SET_VENDOR_STATS, payload: result.data.statisticsData });
    } 
    catch {
        popUpAlert({
            title: "Error",
            text: "Failed to Process the request!",
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: "OK"
        });
        console.log("Failed");
    }
}

function* getStoreStatsSage(props) {
    let url =  `${API_URL}/store/stats`;
    try {
        const uri = url;
        const result = yield call(axiosInstance.post, uri, props.payload);
        yield put({ type: actionTypes.SET_STORE_STATS, payload: result.data });
    } 
    catch {
        popUpAlert({
            title: "Error",
            text: "Failed to Process the request!",
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: "OK"
        });
        console.log("Failed");
    }
}

export const watchGetVendorStatsSaga = function*() {
    yield takeLatest(actionTypes.GET_VENDOR_STATS, getVendorStatsSaga);
};

export const watchGetStoreStatsSage = function*() {
    yield takeLatest(actionTypes.GET_STORE_STATS, getStoreStatsSage);
};